var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfileImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12979_10308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 35.25C27.5269 35.25 35.25 27.5269 35.25 18C35.25 8.47309 27.5269 0.75 18 0.75C8.47309 0.75 0.75 8.47309 0.75 18C0.75 27.5269 8.47309 35.25 18 35.25Z",
    fill: "#8F9DD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7077 26.439L21.75 23.25V17.8044H14.25V23.25L7.29218 26.439C6.1626 26.9566 5.25027 28.3792 5.25 29.6181C8.40482 33.0783 12.9487 35.25 18 35.25C23.0512 35.25 27.5951 33.0783 30.7499 29.6181C30.7496 28.3809 29.8355 26.9558 28.7077 26.439Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21.75C14.6863 21.75 12 19.0637 12 15.75V13.5C12 10.1863 14.6863 7.5 18 7.5C21.3137 7.5 24 10.1863 24 13.5V15.75C24 19.0637 21.3137 21.75 18 21.75Z",
    fill: "#E9ECEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12979_10308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileImg);
export default __webpack_public_path__ + "static/media/userProfile_img.5bdb88d57ae4d63817c33cb56ac6a419.svg";
export { ForwardRef as ReactComponent };